import { useCallback, useMemo, useState } from 'react';
import { comma, toNumber, won } from './data';
import { CONTRACT_MONTHS, calcEstimate } from './estimate';

/** 줄바꿈 없는 공백 — 좁은 화면에서 '× / 12개월'처럼 곱셈식이 끊기지 않게 한다 */
const NB = ' ';

/** 히어로 '예상 납부금액' 카드 상태 */
export default function useEstimate() {
  const [sales, setSales] = useState(5000); // 월평균 온라인·카드매출 (만원)
  const [margin, setMargin] = useState(20); // 이익률 (%)

  const onSales = useCallback((e) => setSales(toNumber(e.target.value)), []);
  const onMargin = useCallback((e) => setMargin(Math.min(100, toNumber(e.target.value))), []);

  return useMemo(() => {
    const { yearSales, costRate, costAmount, limit, monthPay, monthBurden } = calcEstimate(
      sales,
      margin,
    );

    return {
      salesVal: comma(sales),
      marginVal: String(margin),
      onSales,
      onMargin,

      yearSalesLabel: won(yearSales),
      yearSalesNote: `월평균 매출 ${won(sales)}${NB}×${NB}12개월`,

      costAmountLabel: won(costAmount),
      costAmountNote: `1년 매출액 ${won(yearSales)}${NB}×${NB}${costRate}%`,
      costBasisNote: `※ 이익률 ${margin}% 기준, 매입·필요경비 비율 ${costRate}%로 계산`,

      limitLabel: won(limit),
      periodLabel: `${CONTRACT_MONTHS}개월`,
      monthPayLabel: won(monthPay),
      monthBurdenLabel: won(monthBurden),
    };
  }, [margin, onMargin, onSales, sales]);
}
